<gallery-thumb [gallery]="selfInstance"></gallery-thumb>
